const LoginPage = () => {
  return <>This is the login page</>;
};

export default LoginPage;
